export const DEFAULT_TIMES = ['05:55', '06:55', '07:55', '16:55', '17:55'];
export const MAX_FILE_SIZE = 2 * 1024 * 1024 * 1024; // 2GB
export const MAX_SCHEDULE_DAYS = 180;
export const MIN_SCHEDULE_MINUTES = 3;
